export type MyFatoorahTransactionStatus = 'paid' | 'pending' | 'failed' | 'cancelled';
export type MyFatoorahCallbackStatus =
  | 'paid'
  | 'pending'
  | 'failed'
  | 'cancelled'
  | 'expired'
  | 'unknown'
  | 'not_received';

export type WaredSyncStatus = 'success' | 'pending' | 'failed';

export interface AdminMyFatoorahTransactionItem {
  payment_id: string;
  provider_payment_id: string | null;
  provider_invoice_id: string | null;
  product_id: string;
  product_name: string;
  plan_id: string;
  plan_name: string;
  tenant_id: string;
  tenant_name: string;
  customer_name: string | null;
  customer_email: string | null;
  amount: number;
  currency: string;
  status: MyFatoorahTransactionStatus;
  created_at: string;
  updated_at: string;
}

export interface AdminMyFatoorahTransactionsListResponse {
  items: AdminMyFatoorahTransactionItem[];
  next_cursor: string | null;
  total: number;
}

export interface RawProviderPayload {
  sendPaymentResponse?: Record<string, unknown> | null;
  getPaymentStatusResponse?: Record<string, unknown> | null;
}

export interface AdminMyFatoorahTransactionDetails {
  payment_id: string;
  provider_payment_id: string | null;
  provider_invoice_id: string | null;
  checkout_session_id: string | null;
  subscription_id: string;
  tenant_id: string;
  product_id: string;
  product_name: string;
  plan_id: string;
  plan_name: string;
  customer_name: string | null;
  customer_email: string | null;
  amount: number;
  currency: string;
  status: MyFatoorahTransactionStatus;
  raw_provider_payload: RawProviderPayload;
  callback_status: MyFatoorahCallbackStatus;
  callback_received_time: string | null;
  wared_sync_status: WaredSyncStatus;
  wared_sync_attempts: number;
  wared_sync_last_error: string | null;
  created_at: string;
  updated_at: string;
}

export interface ListAdminMyFatoorahTransactionsQuery {
  status?: MyFatoorahTransactionStatus;
  product_id?: string;
  search?: string;
  from?: string;
  to?: string;
  invoice_id?: string;
  payment_id?: string;
  cursor?: string;
  limit?: number;
}

export const MYFATOORAH_TRANSACTION_STATUS_OPTIONS: MyFatoorahTransactionStatus[] = [
  'paid',
  'pending',
  'failed',
  'cancelled',
];
